import { useJwt } from "react-jwt";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { Icon } from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useEffect, useState } from "react";
import { getByIdTag, GetProductStatus } from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";

function ViewTag() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
    if (isExpired) navigate("/");

    const { tagid } = useParams();
    const [tagData, setTagData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [statusData, setStatusData] = useState([]);

    const formatUTCDate = (utcDateString) => {
      const date = new Date(utcDateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
      hours = String(hours).padStart(2, "0");
      return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    useEffect(() => {
        (
          async () => {
              setLoading(true);
                try {
                  const response = await getByIdTag(tagid, localStorage.getItem('accessToken'));
                  setLoading(false);  
                  setTagData(response?.data?.response);
                } catch (error) {
                    console.log(error);
                } finally {
                  setLoading(false);
                }
            }
        )();
    }, []);
  
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        if (tagData) {
          const statusid = tagData.statusid;
          const matchedStatus = statusResponse.data.find(
            (s) => s.statusid === statusid
          );
          setStatusData(matchedStatus);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [tagData]);
    
    
    return (
      <div className="dashboard-content">
        <Sidebar />
        <div className="body-cart tab-content dasContent p-4 bg-white rounded">
          <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
            <h1 className="heading h4 mb-0 fw-bold">Tag Details</h1>
            <div className="d-inline-flex gap-2">
              <NavLink to="/tags" className="btn btn-primary addSeller">
                <Icon className="eye" icon={eye} size={18} /> View All
              </NavLink>
              <NavLink
                to={`/editTag/${tagid}`}
                className="btn btn-primary addSeller"
              >
                <Icon className="arrowUpRight" icon={arrowUpRight} size={18} />{" "}
                Edit
              </NavLink>
            </div>
          </div>
          {
            loading ?
              <div className="d-flex align-items-center justify-content-center">
                <RiLoaderFill size={40} className="text-success spin-animation text-center" />
              </div>
              :
              <div className="detailsBox">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover w-100">
                        <tbody>
                          <tr>
                            <th>Tag Title</th>
                            <td>{tagData?.title}</td>
                          </tr>
                          <tr>
                            <th>Status</th>
                            <td>{statusData?.status}</td>
                          </tr>
                          <tr>
                            <th>Created By</th>
                            <td>{tagData?.createdby}</td>
                          </tr>
                          <tr>
                            <th>Modified By</th>
                            <td>{tagData?.modifiedby}</td>
                          </tr>
                          <tr>
                            <th>Created Date</th>
                            <td>{formatUTCDate(tagData?.createddate)}</td>
                          </tr>
                          <tr>
                            <th>Created Date</th>
                            <td>{formatUTCDate(tagData?.modifieddate)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
          }
        </div>
      </div>
    );
};

export default ViewTag;